










































































































































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  useFetch,
  watch,
  useRouter,
  useContext,
} from "@nuxtjs/composition-api";
import useCart from "~/modules/checkout/composables/useCart";
import { useCartView } from "~/modules/checkout/composables/useCartView";
import { useUser } from "~/modules/customer/composables/useUser";
import { useCartStore } from "~/modules/checkout/stores/cart";
import useShippingProvider from "~/modules/checkout/composables/useShippingProvider";
import { useConfigStore, useShippingStore } from "~/stores/extensionApi";
import useShipping from "~/modules/checkout/composables/useShipping";
import { useRegionStore } from "~/stores/extensionApi/region";
import useMakeOrder from "~/modules/checkout/composables/useMakeOrder";
import useBilling from "~/modules/checkout/composables/useBilling";
import { useAddresses, useGuestUser, usePaymentProvider } from "~/composables";
import { removeItem } from "~/helpers/asyncLocalStorage";
import { useUiState } from "~/composables/useUiState";

import CheckoutNotification from "~/modules/checkout/components/checkoutComponent/CheckoutNotification.vue";
import CheckoutGuest from "~/modules/checkout/components/checkoutComponent/CheckoutGuest.vue";
import CheckoutAddress from "~/modules/checkout/components/checkoutComponent/CheckoutAddress.vue";
import CheckoutDelivery from "~/modules/checkout/components/checkoutComponent/CheckoutDelivery.vue";
import CheckoutShipping from "~/modules/checkout/components/checkoutComponent/CheckoutShipping.vue";
import CheckoutPayment from "~/modules/checkout/components/checkoutComponent/CheckoutPayment.vue";
import CheckoutReview from "~/modules/checkout/components/checkoutComponent/CheckoutReview.vue";
import CheckoutCoupon from "~/modules/checkout/components/checkoutComponent/CheckoutCoupon.vue";
import CheckoutPrice from "~/modules/checkout/components/checkoutComponent/CheckoutPrice.vue";
import PhoneAuthenModal from "~/modules/checkout/components/checkoutComponent/PhoneAuthenModal.vue";
import CheckoutCouponMobile from "~/modules/checkout/components/checkoutComponent/CheckoutCouponMobile.vue";
import LoginWithExistingPhone from "~/modules/checkout/components/checkoutComponent/LoginWithExistingPhone.vue";
const CouponCartModal = () =>
  import(
    "~/modules/checkout/components/cartSidebar/coupon/CouponCartModal.vue"
  );
const AddressNewCustomerModal = () =>
  import(
    "~/modules/checkout/components/checkoutComponent/address/AddressNewCustomerModal.vue"
  );
const AddressNewModal = () =>
  import(
    "~/modules/checkout/components/checkoutComponent/address/AddressNewModal.vue"
  );
import CheckoutInvoices from "~/modules/checkout/components/checkoutComponent/CheckoutInvoices.vue";

import { City, ShippingMethod } from "~/modules/checkout/types";
import {
  CustomerAddress,
  CustomerAddressAttribute,
  Cart,
} from "~/modules/GraphQL/types";
import { useCustomerStore } from "~/modules/customer/stores/customer";
import { useUiNotification } from "~/composables";
import { useClevertapStore } from "~/stores/clevertap";
import {
  getPrice,
  getColorLabel,
  getSizeLabel,
} from "~/modules/checkout/helpers";
import { useEcommercePixel } from "~/stores/ecommercePixel";
import { ParamVoucherInfo, Voucher } from "~/composables/useVoucher/useVoucher";
import { useVoucher } from "~/composables/useVoucher";
import { useOrderStore } from "~/stores/extensionApi/order";

export default defineComponent({
  name: "CheckoutPage",
  layout: "checkout",
  components: {
    CheckoutNotification,
    CheckoutGuest,
    CheckoutAddress,
    CheckoutDelivery,
    CheckoutShipping,
    CheckoutPayment,
    CheckoutReview,
    CheckoutCoupon,
    CheckoutPrice,
    AddressNewModal,
    AddressNewCustomerModal,
    CouponCartModal,
    PhoneAuthenModal,
    CheckoutCouponMobile,
    CheckoutInvoices,
    LoginWithExistingPhone,
  },
  setup() {
    const cartView = useCartView();
    const regionStore = useRegionStore();
    const { cart, load, loading: loadingCart, setCart, clear } = useCart();
    const cartStore = useCartStore();
    const cartState = computed(() => cartStore.cart);
    const customerStore = useCustomerStore();
    const userCurrent = computed(() => customerStore.user);
    const { save: saveShippingProvider } = useShippingProvider();
    const { save: saveShipping } = useShipping();
    const { save: saveAddress } = useAddresses();
    const shippingStore = useShippingStore();
    const orderStore = useOrderStore();
    const configStore = useConfigStore();
    const customerTax = computed(() => {
      return configStore.getCustomerTax?.isActive;
    });
    const { isSuccessLogin } = useUiState();

    const { save: savePaymentMethod } = usePaymentProvider();

    const { app } = useContext();
    const router = useRouter();

    const { send: sendNotification, notifications } = useUiNotification();
    const { make, loading } = useMakeOrder();
    const { save: saveBilling } = useBilling();
    const { attachToCart } = useGuestUser();
    const clevertapStore = useClevertapStore();

    const openNewAddressModal = ref(false);
    const { isAuthenticated, load: loadCurrentUser, user } = useUser();
    const isPhoneAuthent = ref(false);

    const address = computed(() => {
      return (
        cartState.value?.shipping_addresses?.[0] ||
        userCurrent.value?.addresses?.find(
          (address) => address.default_shipping === true
        ) ||
        userCurrent.value?.addresses?.[0] ||
        null
      );
    });

    const guestPhone = computed(() => {
      return address.value?.telephone || null;
    });

    const isCurrentAddress = computed(() => {
      return (
        userCurrent.value?.addresses && userCurrent.value?.addresses.length > 0
      );
    });

    const skuQty = computed(() => {
      return cartView.products.value
        .map((item) => item.product.sku + "_" + item.quantity)
        .join(",");
    });

    const amountOrder = computed(() => {
      return cartView.totals.value.total;
    });

    const setShippingMethod = async (provinceId: string) => {
      if (!provinceId) return;

      if (provinceId && provinceId !== "") {
        const params = {
          skus: skuQty.value,
          province_id: provinceId,
          amount_order: amountOrder.value,
          loyalty_point: 0,
        };
        await shippingStore.getShippings(params);
      }
    };

    const shippingMethods = computed(() => {
      return shippingStore.getShippingMethod as ShippingMethod[];
    });

    const loadingShipping = ref(false);
    const loadingCheckout = ref(false);
    const hasLoading = ref(false);
    const visibleNotification = ref(false);

    const handleLoadingCheckout = (isLoading) => {
      loadingCheckout.value = isLoading;
    };

    const getShippingMethod = async (regionId, cityName) => {
      if (!regionId || !cityName) return;
      if (!regionStore.getCityData(regionId)) {
        await regionStore.fetchCityData(regionId);
      }
      cities.value = await regionStore.getCityData(regionId);

      const city = cities.value?.find((city) => city.cityname === cityName);
      const provinceId = city?.province_id || null;

      await setShippingMethod(provinceId);
    };

    const checkAddress = (addressData: CustomerAddress) => {
      if (!addressData) return false;
      const customAttributes =
        (addressData?.custom_attributes as CustomerAddressAttribute[]) || [];
      const customWardCode = customAttributes.find(
        (attr) => attr.attribute_code === "ward"
      )?.value;

      const wardCode =
        addressData?.extension_attributes?.ward || customWardCode || "";

      return (
        addressData.city &&
        addressData.firstname &&
        addressData.telephone &&
        (addressData.region?.region_id ||
          addressData.region?.region_code ||
          addressData.region?.code) &&
        addressData.street &&
        wardCode
      );
    };

    const changeShippingAddress = async (addressData: CustomerAddress) => {
      if (!checkAddress(addressData)) {
        return;
      }
      const addressesAreEqual = areAddressesEqual(addressData, address.value);
      if (
        addressesAreEqual &&
        address.value.selected_shipping_method &&
        address.value.selected_shipping_method.method_code
      ) {
        return;
      }
      try {
        if (hasLoading.value) {
          loadingShipping.value = true;
        }
        const shippingMethod =
          shippingMethods.value?.[0]?.shipping_method || "standard_shipping";

        const customAttributes =
          (addressData?.custom_attributes as CustomerAddressAttribute[]) || [];
        const customWardName = customAttributes.find(
          (attr) => attr?.attribute_code === "ward_name"
        )?.value;
        const customWardCode = customAttributes.find(
          (attr) => attr.attribute_code === "ward"
        )?.value;

        const typeAddress = customAttributes.find(
          (attr) => attr?.attribute_code === "type_address"
        )?.value;

        const wardCode =
          addressData?.extension_attributes?.ward || customWardCode;
        let wardName =
          addressData?.extension_attributes?.ward_name || customWardName;

        const shippingDetails = {
          city: addressData.city,
          country_code: "VN",
          firstname: addressData.firstname,
          lastname: addressData.lastname || "_",
          region:
            addressData.region?.region_code || addressData.region?.code || "",
          street: Array.isArray(addressData?.street)
            ? addressData?.street[0]
            : addressData?.street,
          telephone: addressData.telephone,
          save_in_address_book: false,
          ward: wardCode,
          ward_name: wardName,
          company: addressData?.company || shippingMethod,
          type_address:
            addressData?.extension_attributes?.type_address ||
            typeAddress ||
            "1",
        };

        const methodCode =
          address.value?.selected_shipping_method?.method_code || "";

        await saveShipping({
          shippingDetails: shippingDetails,
        });

        const availableShippingMethod =
          cartState.value?.shipping_addresses?.[0]?.available_shipping_methods?.find(
            (method) => method.carrier_code === "matrixrate"
          );

        if (
          availableShippingMethod &&
          methodCode !== availableShippingMethod.method_code
        ) {
          try {
            const shippingData = {
              carrier_code: availableShippingMethod.carrier_code,
              method_code: availableShippingMethod.method_code,
            };

            await saveShippingProvider({
              shippingMethod: shippingData,
            });

            formValidationStatus.value = true;
          } catch (error) {
            console.error("Error setting shipping method:", error);
          }
        }
        await load();
      } catch (error) {
        console.log("error: ", error);
      } finally {
        loadingShipping.value = false;
        hasLoading.value = false;
      }
    };

    const getWardNameByWardCode = async (cityId, wardCode: string) => {
      if (!wardCode || !cityId) return "";
      await regionStore.fetchWardData(cityId);
      const wards = regionStore.getWardData(cityId);
      const ward = wards?.find((w) => w.ward_code === wardCode);
      return ward ? ward?.ward_name : "";
    };
    const wardNameByWard = ref("");
    const showAddress = computed(() => {
      let wardName =
        address.value?.extension_attributes?.ward_name ||
        wardNameByWard.value ||
        "";

      const street = Array.isArray(address.value?.street)
        ? address.value?.street[0]
        : address.value?.street;
      const city = address.value?.city || "";
      const region =
        address.value?.region?.region || address.value?.region?.label || "";

      const addressShow = `${street}, ${wardName}, ${city}, ${region}`;
      return addressShow;
    });

    const typeAddress = computed(() => {
      return address.value?.extension_attributes?.type_address || "1";
    });

    const isEdit = ref(false);
    const toggleNewAddressModal = () => {
      isEdit.value = false;
      openNewAddressModal.value = true;
    };
    const toggleEditAddressModal = () => {
      isEdit.value = true;
      openNewAddressModal.value = true;
    };

    const openNewAddressCustomerModal = ref(false);
    const toggleEditAddressCustomerModal = () => {
      openNewAddressCustomerModal.value = true;
    };

    const cities = ref<City[]>([]);

    const areAddressesEqual = (address1, address2) => {
      if (!address1 || !address2) {
        return false;
      }

      if (
        address1.firstname !== address2.firstname ||
        address1.telephone !== address2.telephone ||
        address1.city !== address2.city
      ) {
        return false;
      }

      const region1Id = address1.region?.region_id;
      const region2Id = address2.region?.region_id;
      if (region1Id !== region2Id) {
        return false;
      }

      const street1 = Array.isArray(address1.street)
        ? address1.street[0]
        : address1.street;
      const street2 = Array.isArray(address2.street)
        ? address2.street[0]
        : address2.street;
      if (street1 !== street2) {
        return false;
      }

      const ward1 =
        address1.extension_attributes?.ward ||
        address1?.custom_attributes?.find(
          (attr) => attr.attribute_code === "ward"
        )?.value;
      const ward2 =
        address2.extension_attributes?.ward ||
        address2?.custom_attributes?.find(
          (attr) => attr.attribute_code === "ward"
        )?.value;
      if ((ward1 || ward2) && ward1 !== ward2) {
        return false;
      }

      const typeAddress1 =
        address1.extension_attributes?.type_address ||
        address1?.custom_attributes?.find(
          (attr) => attr.attribute_code === "type_address"
        )?.value;
      const typeAddress2 =
        address2.extension_attributes?.type_address ||
        address2?.custom_attributes?.find(
          (attr) => attr.attribute_code === "type_address"
        )?.value;
      if ((typeAddress1 || typeAddress2) && typeAddress1 !== typeAddress2) {
        return false;
      }

      const company1 = address1.company;
      const company2 = address2.company;
      if (company1 !== company2) {
        return false;
      }

      return true;
    };

    const isCartEmpty = computed(() => {
      return !cartState.value || cartState.value?.items?.length === 0;
    });

    // Enhance the existing trackCheckoutStarted function to track each item
    const trackCheckoutStarted = () => {
      try {
        if (process.client) {
          const win = window as any;
          if (win.clevertap && cartView.products.value.length > 0) {
            const cartItems = cartView.products.value;

            // First track the overall checkout
            // Calculate total cart quantities and revenue
            let checkoutQuantity = 0;
            let checkoutRevenue = 0;

            // Prepare the checkout data object
            const checkoutData: Record<string, any> = {
              checkout_id: app.$vsf.$magento.config.state.getCartId(),
              checkout_quantity: 0,
              checkout_revenue: 0,
              checkout_subtotal: cartView.totals.value?.subtotal || 0,
              free_shipping_qualified: cartView.freeShipPrice.value <= 0,
            };

            // Add each product's data with indexed properties
            cartItems.forEach((item, index) => {
              const productIndex = index + 1;
              const product = item.product;
              const productParent = item.productParent;
              const priceInfo = getPrice(item);
              const quantity = item.quantity;

              // Get parent SKU if available, fallback to direct SKU

              const parentSku = product.sku?.split("-").slice(0, -1).join("-");
              // Get color and size from parent variants if available
              const color = productParent
                ? getColorLabel(
                    productParent.configurable_children,
                    product.sku,
                    productParent.configurable_options_map
                  )
                : "";

              const size = productParent
                ? getSizeLabel(
                    productParent.configurable_children,
                    product.sku,
                    productParent.configurable_options_map
                  )
                : "";

              // Calculate individual and running totals
              const itemSubtotal =
                (priceInfo.special || priceInfo.final) * quantity;
              checkoutQuantity += quantity;
              checkoutRevenue += itemSubtotal;

              // Add product-specific properties with index
              checkoutData[`product_id_${productIndex}`] = parentSku;
              checkoutData[`product_title_${productIndex}`] = productParent
                ? productParent.name
                : product.name;
              checkoutData[`product_price_${productIndex}`] =
                priceInfo.special || priceInfo.final || priceInfo.regular;
              checkoutData[`item_id_${productIndex}`] = product.sku;
              checkoutData[`item_quantity_${productIndex}`] = quantity;
              checkoutData[`item_currency_${productIndex}`] = "VND";
              checkoutData[`item_color_name_${productIndex}`] = color;
              checkoutData[`item_size_${productIndex}`] = size;
              checkoutData[`item_subtotal_${productIndex}`] = itemSubtotal;
            });

            // Update total checkout quantities and revenue
            checkoutData.checkout_quantity = checkoutQuantity;
            checkoutData.checkout_revenue = checkoutRevenue;

            // Also try through store for backward compatibility
            if (typeof clevertapStore.checkoutStartedCleverTap === "function") {
              clevertapStore.checkoutStartedCleverTap({
                clevertap: win.clevertap,
                data: checkoutData,
              });
            }

            // Create standard product data objects for tracking
            const cartProducts = cartItems.map((item) => {
              const product = item.product;
              const productParent = item.productParent;
              const priceInfo = getPrice(item);
              return {
                parentSku: productParent?.sku?.includes("-")
                  ? product?.sku?.substring(0, product?.sku?.lastIndexOf("-"))
                  : productParent?.sku,
                sku: product?.sku,
                name: productParent ? productParent.name : product.name,
                title: productParent ? productParent.name : product.name,
                original_price: priceInfo.regular || 0,
                final_price: priceInfo.final || 0,
                price: priceInfo.special || priceInfo.regular || 0,
                sale_price: priceInfo.regular - (priceInfo.final || 0),
                description: productParent?.description_map || "",
                url_path: product?.url_key || "",
                qty: item.quantity,
                image:
                  productParent?.media_gallery &&
                  productParent?.media_gallery.length > 0
                    ? productParent?.media_gallery.map((img) => ({
                        image: img.image,
                      }))
                    : productParent?.image_map
                    ? [
                        {
                          image:
                            process.env.IMG_BASE_URL +
                            "/catalog/product" +
                            productParent?.image_map,
                        },
                      ]
                    : [],
              };
            });

            // Initialize ecommerce pixel store
            const ecommercePixelStore = useEcommercePixel();

            // Prepare user data and common tracking parameters
            const userData =
              isAuthenticated.value && user.value ? user.value : null;

            // Add Facebook Pixel tracking for InitiateCheckout
            if (win.fbq) {
              const fbqTrackingData = {
                contentsFbq: cartProducts.map((p) => ({
                  id: p.parentSku,
                  quantity: p.qty,
                  item_price: p.final_price,
                })),
                content_ids: cartProducts.map((p) => p.parentSku),
                content_name: cartProducts.map((p) => p.name).join(", "),
                value: checkoutRevenue,
                number_items: checkoutQuantity,
                currency: "VND",
                userData: userData,
              };

              ecommercePixelStore.initCheckoutFbq({
                analytics: win.fbq,
                stock: fbqTrackingData,
              });
            }

            // Add Google Tag Manager tracking for InitiateCheckout
            if (win.dataLayer) {
              // Standard GTM tracking
              ecommercePixelStore.initCheckoutGtag({
                dataLayer: win.dataLayer,
                window_dataLayer: win.dataLayer,
                stock: cartProducts.map((p) => ({
                  title: p.title,
                  name: p.name,
                  description: p.description,
                  link: `${process.env.VSF_STORE_URL}/${p.url_path}`,
                  id: p.sku,
                  parent_sku: p?.parentSku,
                  item_id_custom: p.parentSku,
                  price: p.final_price,
                  qty: p.qty,
                  sale_price: p.sale_price,
                })),
              });

              // Google Analytics 4 tracking
              ecommercePixelStore.initCheckoutGa4({
                dataLayer: win.dataLayer,
                window_dataLayer: win.dataLayer,
                stock: cartProducts.map((p) => ({
                  title: p.title,
                  id: p.sku,
                  parent_sku: p.parentSku,
                  item_id_custom: p.parentSku,
                  sale_price: p.sale_price,
                  price: p.final_price,
                  qty: p.qty,
                })),
              });
            }

            // Add TikTok Pixel tracking for InitiateCheckout
            if (win.ttq) {
              ecommercePixelStore.initCheckoutTiktok({
                ttq: win.ttq,
                stock: {
                  contents: cartProducts.map((p) => ({
                    content_id: p.parentSku,
                    content_type: "product",
                    content_name: p.name,
                    quantity: p.qty,
                    price: p.final_price,
                  })),
                  value: checkoutRevenue,
                  currency: "VND",
                },
              });
            }
          } else {
            console.warn(
              "CleverTap is not available or cart is empty:",
              !!win.clevertap,
              cartView.products.value.length
            );
          }
        }
      } catch (error) {
        console.error("Error tracking checkout started:", error);
      }
    };

    const { fetch } = useFetch(async () => {
      loadingShipping.value = true;
      if (!isAuthenticated.value) {
        await load();
      }

      if (isAuthenticated.value) {
        await Promise.all([loadCurrentUser(), load()]);
        // Khi đăng nhập, nếu cart chưa có địa chỉ thì lấy địa chỉ trong sổ địa chỉ

        if (!address.value) {
          const customerAddress =
            userCurrent.value?.addresses?.find(
              (address) => address.default_shipping === true
            ) ||
            userCurrent.value?.addresses?.[0] ||
            null;

          if (customerAddress) {
            await changeShippingAddress(customerAddress as CustomerAddress);
          }
        }
        formValidationStatus.value = true;
      }
      if (address.value && address.value?.region && address.value?.city) {
        const regionId = address.value?.region?.region_id || null;
        const cityName = address.value?.city || null;
        if (regionId && cityName) {
          await getShippingMethod(regionId, cityName);
        }
      }

      if (
        (address.value && !address.value.selected_shipping_method) ||
        (address.value && !address.value.selected_shipping_method?.method_code)
      ) {
        await changeShippingAddress(address.value as CustomerAddress);
      }

      if (
        address.value &&
        address.value.extension_attributes?.ward &&
        !address.value.extension_attributes?.ward_name
      ) {
        const regionId = address.value?.region?.region_id || "";
        if (regionId) {
          await regionStore.fetchCityData(regionId);
          const cities = regionStore.getCityData(regionId);
          const cityId = cities?.find(
            (city) => city.cityname == address.value.city
          )?.city_id;
          wardNameByWard.value = await getWardNameByWardCode(
            cityId,
            address.value.extension_attributes.ward
          );
        }
      }
      loadingShipping.value = false;
    });

    // Track checkout flag to ensure we only track once
    const hasTrackedCheckout = ref(false);
    const checkWard = computed(() => {
      return (
        isAuthenticated.value &&
        address.value &&
        address.value.extension_attributes &&
        !address.value.extension_attributes?.ward
      );
    });

    onMounted(async () => {
      if (isCartEmpty.value) {
        router.push("/");
        sendNotification({
          id: Symbol("cart_empty"),
          message:
            "Giỏ hàng trống. Vui lòng thêm sản phẩm trước khi vào thanh toán!",
          type: "info",
          icon: "error",
          persist: false,
          title: "Giỏ hàng trống",
        });
      } else {
        // Only track if we haven't tracked already
        if (!hasTrackedCheckout.value) {
          setTimeout(() => {
            if (!isCartEmpty.value) {
              trackCheckoutStarted();
              hasTrackedCheckout.value = true;
            }
          }, 2000);
        }
      }
    });

    const formValidationStatus = ref(false);
    watch(
      () => isSuccessLogin.value,
      async (newVal, oldVal) => {
        if (newVal === true && oldVal === false && !isLogin.value) {
          isLoginWithExistingPhone.value = false;
          phoneNumber.value = "";
          fetch();
        }
      }
    );

    const closeModal = async () => {
      openNewAddressCustomerModal.value = false;
    };

    const order = ref(null);
    const errorCart = ref("");
    const customerToken = computed(() =>
      app.$vsf.$magento.config.state.getCustomerToken()
    );
    const selectedPaymentMethod = computed(() => {
      return cartState.value?.selected_payment_method?.code || null;
    });

    const cartTemp = ref<Cart | null>(null);

    const checkoutCompleted = async () => {
      try {
        loadingCheckout.value = true;
        errorCart.value = await cartView.checkExitCart();
        if (errorCart.value) {
          sendNotification({
            id: Symbol("errorCart"),
            message: errorCart.value,
            type: "warning",
            icon: "error",
            persist: false,
            title: errorCart.value,
          });
          return;
        } else {
          // Prepare shipping and billing details as before
          const shippingAddress =
            cartState.value?.shipping_addresses[0] || null;
          const taxinfo = localStorage.getItem("cnf/checkout/taxinfo");
          const shippingDetails = {
            city: shippingAddress.city,
            country_code: "VN",
            firstname: shippingAddress.firstname,
            lastname: shippingAddress.lastname || "_",
            region:
              shippingAddress.region?.region_code ||
              shippingAddress.region?.code ||
              "",
            street: shippingAddress.street[0] || "",
            telephone: shippingAddress.telephone,
            save_in_address_book: false,
            ward: shippingAddress?.extension_attributes?.ward,
            ward_name: shippingAddress?.extension_attributes?.ward_name,
            company: shippingAddress.company,
            customer_tax_info: "",
          };
          const billingDetailsData = {
            billingDetails: {
              ...shippingDetails,
            },
          };

          // Thêm thông tin thuế nếu có
          if (customerTax.value && taxinfo) {
            billingDetailsData.billingDetails.customer_tax_info = taxinfo;
          }

          // Nếu là khách hàng hàng mới muốn đăng ký
          if (isLogin.value && !customerToken.value) {
            cartTemp.value = cartState.value;
            phoneNumber.value = shippingAddress.telephone;
            isLoginWithExistingPhone.value = true;
            return;
          }

          await saveBilling(billingDetailsData);

          if (!cartState.value?.email) {
            const email = shippingAddress.telephone + "@cnf.com";
            await attachToCart({ email: email, cart });
          }

          if (
            selectedPaymentMethod.value == "cashondelivery" &&
            !customerToken.value
          ) {
            isPhoneAuthent.value = true;
            return;
          }

          order.value = await make();
          if (typeof order.value == "string") {
            sendNotification({
              id: Symbol("errorOrder"),
              message: order.value,
              type: "warning",
              icon: "error",
              persist: false,
              title: "Order Error",
            });
            return;
          }

          const paymentOder = directUrl();
          // Clear cart and redirect
          await clearCartCheckout();
          // await removeItem("checkout");
          await router.push(paymentOder);

          // Xóa thông tin thuế từ localStorage
          if (taxinfo) {
            localStorage.removeItem("cnf/checkout/taxinfo");
          }
        }
      } finally {
        loadingCheckout.value = false;
      }
    };

    const loginCheckoutGuest = async () => {
      isLoginWithExistingPhone.value = false;
      phoneNumber.value = "";

      try {
        loadingCheckout.value = true;
        const cartIdOld = cartTemp.value?.id;
        const cartId = cartState.value?.id;
        if (cartIdOld && cartId && cartIdOld == cartId) {
          await load();
        }

        const addressData = cartTemp.value
          ?.shipping_addresses[0] as CustomerAddress;

        const paymentMethodCode = cartTemp.value?.selected_payment_method?.code;

        // call lại data đã nhập từ trước
        const shippingDetails = {
          city: addressData.city,
          country_code: "VN",
          firstname: addressData.firstname,
          lastname: addressData.lastname || "_",
          region:
            addressData.region?.region_code || addressData.region?.code || "",
          street: Array.isArray(addressData?.street)
            ? addressData?.street[0]
            : addressData?.street,
          telephone: addressData.telephone,
          save_in_address_book: false,
          ward: addressData?.extension_attributes?.ward,
          ward_name: addressData?.extension_attributes?.ward_name,
          company: addressData?.company,
          type_address: addressData?.extension_attributes?.type_address || "1",
          customer_tax_info:
            addressData?.extension_attributes?.customer_tax_info || "",
        };

        const billingDetailsData = {
          billingDetails: {
            ...shippingDetails,
          },
        };

        const shippingData = {
          carrier_code:
            addressData?.selected_shipping_method?.carrier_code || "",
          method_code: addressData?.selected_shipping_method?.method_code || "",
        };

        const newAddressData = {
          country_code: "VN",
          firstname: addressData.firstname,
          lastname: "-",
          telephone: addressData.telephone,
          region: { region_id: addressData.region?.region_id },
          city: addressData.city,
          street: Array.isArray(addressData?.street)
            ? addressData?.street[0]
            : addressData?.street,
          default_shipping: false,
          custom_attributes: [
            {
              attribute_code: "ward",
              value: addressData?.extension_attributes?.ward,
            },
            {
              attribute_code: "ward_name",
              value: addressData?.extension_attributes?.ward_name,
            },
            {
              attribute_code: "type_address",
              value: addressData?.extension_attributes?.type_address,
            },
          ],
        } as unknown as CustomerAddress;

        await saveShipping({
          shippingDetails: shippingDetails,
        });
        await saveBilling(billingDetailsData);
        await saveAddress({ address: newAddressData });

        if (shippingData?.carrier_code && shippingData.method_code) {
          await saveShippingProvider({
            shippingMethod: shippingData,
          });
        }

        if (paymentMethodCode) {
          await savePaymentMethod({
            paymentMethod: {
              code: paymentMethodCode,
            },
          });
        }
        sendNotification({
          id: Symbol("order_checking"),
          message:
            "Tiến trình thanh toán đang được thực hiện, vui lòng đợi trong giây lát.",
          type: "info",
          icon: "info",
          persist: false,
          title: "Verify order",
        });

        // Rest of function logic remains the same
        order.value = await make();
        if (typeof order.value == "string") {
          sendNotification({
            id: Symbol("errorOrder"),
            message: order.value,
            type: "warning",
            icon: "error",
            persist: false,
            title: "Order Error",
          });
          return;
        }
        const phoneNumber =
          cartState.value?.shipping_addresses[0]?.telephone || "";

        const paymentOder = directUrl();
        // Clear cart and redirect
        await clearCartCheckout();
        await router.push(paymentOder);

        // Xóa thông tin thuế từ localStorage
        const taxinfo = localStorage.getItem("cnf/checkout/taxinfo");
        if (taxinfo) {
          localStorage.removeItem("cnf/checkout/taxinfo");
        }

        // sendNotification({
        //   id: Symbol("register_success"),
        //   message: `Bạn đã tạo tài khoản thành <br/> công với số điện thoại <br/><strong>${phoneNumber}</strong>`,
        //   type: "secondary",
        //   icon: "",
        //   isProduct: true,
        //   isRegistered: true,
        //   urlPath: "/customer/my-profile",
        //   time: 10000,
        //   persist: false,
        // });
      } catch (error) {
        console.error("Error during loginCheckoutGuest:", error);
      } finally {
        loadingCheckout.value = false;
      }
    };

    const clearCartCheckout = async () => {
      if (customerToken.value) {
        try {
          setCart(null);
          app.$vsf.$magento.config.state.removeCartId();
          await app.$vsf.$magento.api.createEmptyCart();
          orderStore.$patch((state) => {
          state.listOrder = null;
        });
        } catch (e) {
          console.error("Error clearing authenticated user cart:", e);
        }
      } else {
        setCart(null);
        app.$vsf.$magento.config.state.removeCartId();
      }
    };

    const directUrl = () => {
      const orderNumber = order.value.order.order_number;
      let paymentOder;

      if (selectedPaymentMethod.value == "cashondelivery") {
        paymentOder = app.localeRoute({
          name: "orderdetailpayonline",
          query: {
            increment_id: orderNumber,
            method: selectedPaymentMethod.value,
            phone_number:
              cartState.value?.shipping_addresses[0]?.telephone || "",
            status: "success",
            ...(isLogin.value ? { newUser: "1" } : {}),
          },
        });
      } else {
        paymentOder = app.localeRoute({
          name: "orderdetailpayonline",
          query: {
            increment_id: orderNumber,
            method: selectedPaymentMethod.value,
            phone_number:
              cartState.value?.shipping_addresses[0]?.telephone || "",
            status: "pending",
            ...(isLogin.value ? { newUser: "1" } : {}),
          },
        });
      }
      return paymentOder;
    };

    const checkOutGuest = async () => {
      try {
        loadingCheckout.value = true;
        order.value = await make();
        if (typeof order.value == "string") {
          sendNotification({
            id: Symbol("errorOrder"),
            message: order.value,
            type: "warning",
            icon: "error",
            persist: false,
            title: "Order Error",
          });
          return;
        }
        const paymentOder = directUrl();
        // Clear cart and redirect
        await clearCartCheckout();
        await removeItem("checkout");
        await router.push(paymentOder);

        // Xóa thông tin thuế từ localStorage
        if (localStorage.getItem("cnf/checkout/taxinfo")) {
          localStorage.removeItem("cnf/checkout/taxinfo");
        }
      } catch (error) {
        console.error("Error during checkout:", error);
      } finally {
        loadingCheckout.value = false;
      }
    };

    const isVisibleCoupon = ref(false);
    const openModalCoupon = async () => {
      if (isVisibleCoupon.value) {
        isVisibleCoupon.value = false;
        return;
      }
      isVisibleCoupon.value = true;
    };

    const confirmRemove = () => {
      visibleNotification.value = false;
    };

    // vouchers
    const { getVoucherInfo } = useVoucher();

    const extensionAttributes = computed(
      () => cartStore?.cart?.extension_attributes
    );
    const appliedCoupons = computed(() =>
      (extensionAttributes.value?.coupon_code_odoo?.split(",") || []).filter(
        (code) => code.trim() !== ""
      )
    );

    const listVoucherApplied = ref(<Voucher[]>[]);
    const getVouchers = async () => {
      const param: ParamVoucherInfo = {
        coupon_code: appliedCoupons.value,
      };
      listVoucherApplied.value = await getVoucherInfo(param);
    };

    watch(
      () => appliedCoupons.value,
      async (newVal, oldVal) => {
        if (newVal.length !== oldVal.length) {
          await getVouchers();
        }
      },
      { immediate: true }
    );

    const phoneNumber = ref("");
    const isLoginWithExistingPhone = ref(false);
    const loginWithPhone = (phone: string) => {
      phoneNumber.value = phone;
      isLoginWithExistingPhone.value = true;
    };

    const isLogin = ref(false);
    const setIsLogin = (value) => {
      isLogin.value = value == 1;
    };

    const loginGuest = () => {
      isLoginWithExistingPhone.value = false;
      phoneNumber.value = "";
      openNewAddressCustomerModal.value = true;
    };

    return {
      ...cartView,
      isAuthenticated,
      openNewAddressModal,
      toggleNewAddressModal,
      toggleEditAddressModal,
      toggleEditAddressCustomerModal,
      loadingCart,
      address,
      isEdit,
      showAddress,
      changeShippingAddress,
      shippingMethods,
      formValidationStatus,
      loadingShipping,
      loadingCheckout,
      handleLoadingCheckout,
      isCurrentAddress,
      openNewAddressCustomerModal,
      closeModal,
      setShippingMethod,
      isCartEmpty,
      isPhoneAuthent,
      guestPhone,
      checkoutCompleted,
      checkOutGuest,
      appliedCouponsOnCart: cartView.appliedCouponsOnCart,
      listVoucher: cartView.listVoucher,
      openModalCoupon,
      isVisibleCoupon,
      typeAddress,
      trackCheckoutStarted,
      hasLoading,
      confirmRemove,
      visibleNotification,
      listVoucherApplied,
      isLoginWithExistingPhone,
      loginWithPhone,
      phoneNumber,
      loginGuest,
      isLogin,
      setIsLogin,
      loginCheckoutGuest,
      checkWard,
    };
  },
});
